export const getModalType = state => state.modal.get('type')
export const getModalProps = state => state.modal.get('props')
